import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import logo from '../../../../../images/shieldgps-logo1.svg';
import { customFetchV2 } from '../../../services/custom-fetch-v2.ts';
import Button from '../../bits/Button.jsx';
import TextField from '../../bits/TextField.jsx';

class PasswordResetIssueTokenForm extends Component {
  state = {
    email: '',
    isLoading: false,
    isComplete: false,
    errorMessage: '',
  };

  formFieldChange = input => (e) => {
    this.setState({ [input]: e.target.value });
  }

  isSubmitDisabled = () => {
    const { email, isLoading } = this.state;
    return email.length === 0 || isLoading;
  }

  handleSubmit = (evt) => {
    evt.preventDefault();

    this.setState({
      isLoading: true,
      errorMessage: '',
    });

    customFetchV2('/password-reset/issue-token', {
      method: 'POST',
      body: JSON.stringify({
        email: this.state.email,
      }),
      skipAuth: true,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Error trying to reset password.');
        }

        return response.data;
      })
      .then((json) => {
        if (!json.success) {
          throw new Error(json.message || 'Unknown error.');
        }

        this.setState({
          isLoading: false,
          isComplete: true,
        });
      })
      .catch((error) => {
        this.setState({
          errorMessage: error.message,
          isLoading: false,
        });
      });
  }

  renderMessageBox = () => {
    if (!this.state.errorMessage) {
      return null;
    }

    return (
      <div className="login__messageBox">
        <WarningRoundedIcon className="login__messageBox__icon" fontSize="small" />{this.state.errorMessage}
      </div>
    );
  }

  renderEmailForm = () => (
    <React.Fragment>
      <form onSubmit={this.handleSubmit}>
        <div className="login__body__title">
          Reset your password
        </div>
        <div className="login__body__instructions">
          Forgotten your password? No problem, just enter your email address
          below and we&apos;ll send you instructions on how to reset it.
        </div>
        <div>
          <TextField
            classes={{ root: 'login-field' }}
            id="email"
            type="email"
            label="Email Address"
            value={this.state.email}
            onChange={this.formFieldChange('email')}
            fullWidth
            margin="normal"
            disabled={this.state.isLoading}
          />
        </div>
        {this.renderMessageBox()}
        <div className="login__body__submit">
          <Button
            type="submit"
            disabled={this.isSubmitDisabled()}
            loading={this.state.isLoading}
            color="primary">
              Continue
          </Button>
        </div>
      </form>
      <div className="login__footer">
        Already have a ShieldGPS account? <a onClick={this.props.onShowLogin}>Log in here</a>
      </div>
     </React.Fragment>
  );

  renderContent = () => {
    if (this.state.isComplete) {
      return (
        <React.Fragment>
          <div className="login__content">
            Thanks, check your email for instructions on how to reset your password.
          </div>
          <div className="login__footer">
            <a onClick={this.props.onShowLogin}>Back to Log in</a>
          </div>
        </React.Fragment>
      );
    }

    return this.renderEmailForm();
  }

  render() {
    return (
      <div className="login">
        <div className="login__header">
          <img src={logo} />
        </div>
        {this.renderContent()}
      </div>
    );
  }
}

PasswordResetIssueTokenForm.propTypes = {
  onShowLogin: PropTypes.func.isRequired,
};

export default PasswordResetIssueTokenForm;
